import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationButton',
  props: {
    isCurrent: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

function handleClick() {
  emit('click');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["rounded border border-teal h-9 aspect-square flex items-center justify-center", _ctx.isCurrent ? 'bg-teal text-white' : 'text-teal disabled:opacity-40']),
    disabled: _ctx.isDisabled || _ctx.isCurrent,
    onClick: _withModifiers(handleClick, ["prevent"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})